export default __webpack_public_path__ + "static/media/attic_D112-2XDF-15-EI60.99d020c0.jpg";